import { render, staticRenderFns } from "./CreateInformationDialog.vue?vue&type=template&id=00fe8003&scoped=true&lang=pug&"
import script from "./CreateInformationDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateInformationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe8003",
  null
  
)

export default component.exports